/**
 * Where each marketplace solution opens in this app.
 *
 * One map shared by the Marketplace cards and the /marketplace/:slug route, so
 * every way into a solution (a card, an Orbit recommendation, a bookmark, a
 * catalog landing_url) lands on the same page. The catalog can list a solution
 * before it has a page of its own; a slug missing here reads "Coming soon" on
 * its card, and its address falls back to the Marketplace instead of a blank
 * screen.
 *
 * WhatsApp Agent and Chatbot SDK are not pages of their own: WhatsApp is a
 * channel of the AI Assistant, and the SDK keys live on its Developer tab.
 */
export const SOLUTION_PAGES: Record<string, string> = {
  chatbot: '/marketplace/chatbot',
  'whatsapp-agent': '/marketplace/chatbot?channel=whatsapp#channels',
  'chatbot-sdk': '/marketplace/chatbot#developer',
};

/** A landing_url on another site; nothing in this app serves it. */
export const isExternalUrl = (url?: string | null): boolean =>
  /^https?:\/\//i.test(url || '');

export const solutionPage = (slug?: string | null): string | null =>
  (slug && SOLUTION_PAGES[slug]) || null;
